import React, {
  useEffect,
  useState,
  useMemo,
  useContext,
} from "react";
import axios from "axios";

import { Link } from "react-router-dom";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import { checkUserPermission } from "../../../../common/UserPermission";

//MUI Table
import CommonMatrialReactTable from "../../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../../common/CurrencySymbol";
import { AppContext } from "../../../../context/AppContext";
import DeleteConfirmation from "../../../../components/Modal/DeleteConfirmation";

const TemporaryActivatedItems = (props) => {
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
    const locationId = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const { CurrencySymbol, FractionDigits, showTemporaryActivatedItems } =
    useContext(AppContext);
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [data, setData] = useState([]);
  const [rowSelectData, setRowSelectData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedItemsCheckboxIDs, setselectedItemsCheckboxIds] = useState("");

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
  }, [rowSelection]);

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    axios
      .get(
        // api in not made
        `${
          config.itemsBaseUrl
        }/items/gettemporaryactivateditems?locationid=${locationId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData,"res.data.ResponseData");
        
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [
    perPageSize,
    searchtext,
    sortingId,
    sortingDirection,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
  ]);

  const handleDeletePopup = (id, rows, field, buttonType) => {
    console.log("buttonType", buttonType);
    let itemids;
    let quickbookids;
    if (field === "multipleRowInactive") {
      // datas = rows.map((el) => el.original.ID).join(",");
      const filteredArray = rows.map((index) => data[index]);
      itemids = filteredArray
        .map((el) =>
          el.VariationId > 0 ? el.VariationId + "V" : el.ItemId + "I"
        )
        .join(",");
      quickbookids = filteredArray.map((el) => el.QuickbookId).join(",");
    } else {
      itemids = id;
    }
    const deleteRequestParam = {
      itemids: itemids,
      quickbookids: quickbookids,
      loginuserid: localStorage.getItem("ID"),
      isTemporaryActive: 1, // 1 for temporary activated items
    };

    console.log(deleteRequestParam, "deleteRequestParam");

    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };


  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ItemId",
      Cell: ({ row }) => {
        const { ItemId, VariationId } = row.original;
        return (
          <span>{VariationId > 0 ? `${ItemId}#${VariationId}` : ItemId}</span>
        );
      },
    },

    // {
    //   header: "UPC/EAN/ISBN",
    //   accessorKey: "UPC/EAN/ISBN",
    // },
    {
      header: "Name",
      accessorKey: "Name",
       Cell: ({ row }) => {
        const { ItemId, VariationId } = row.original;
        return (
          <span>{VariationId > 0 ? row.original.VariationName : row.original.ItemName}</span>
        );
      },
    },
    {
      header: "Category Full Path",
      accessorKey: "CategoryName",
    },
    {
      header: "Cost Price",
      accessorKey: "CostPrice",
      Cell: ({ row }) => {
        return checkUserPermission(PERMISSION_SHOW_COST_PRICE) ? (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.CostPrice),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        ) : (
          ""
        );
      },
    },
    {
      header: "Selling Price",
      accessorKey: "UnitPrice",
      Cell: ({ row }) => parseFloat(row.original.UnitPrice).toFixed(2),
      size: 100,
    },
    // {
    //   header: "Quantity",
    //   accessorKey: "Quantity",
    //   size: 100,
    //   Cell: ({ row }) => {
    //     const { ItemId, VariationId } = row.original;
    //     return (
    //       <span>{VariationId > 0 ? row.original.VariationName : row.original.ItemName}</span>
    //     );
    //   },
    // },
    // {
    //   header: "",
    //   accessorKey:"Image"
    // },
  ]);
  const visibleColumns = columns.filter((columns) => columns.hidden !== false);
  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items List</Link>
                </li>
                <li className="breadcrumb-item active">Deleted Items List</li>
              </ul>
            </div>
          </div>

          <div className="d-flex justify-content-between mb-3">
            {" "}
            <div className="text-center">
              {rowSelectData?.length > 0 && (
                <>
                  <button
                    className="btn btn-dark btn-sm mt-4"
                    onClick={() =>
                      handleDeletePopup(
                        "",
                        rowSelectData,
                        "multipleRowInactive",
                        "Active"
                      )
                    }
                  >
                    Make Inactive
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="row flex-row-reverse"></div>
          <CommonMatrialReactTable
            MainHeading="Sonar POS"
            ReportHeading="Deleted Items List"
            columns={columns}
            data={data}
            columnGrouping={[]}
            columnsVisibility={{}}
            hodiExport={true}
            enableRowSelection={true}
            isRowSelectionManual={true}
            setRowSelectData={setRowSelection}
            state={{ rowSelection }}
          />
        </div>
      </div>

        <DeleteConfirmation
        deleteApiUrl={`${config.itemsBaseUrl}/items/deletemultiple`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default TemporaryActivatedItems;
